// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"4890c63bd92e392a","3877":"fe336940f98fdfab","4450":"4b7618287be037b6","6272":"aa4472f7082b94cd","7584":"d9652db206d50763","7891":"855bb127b5039a9b"}[chunkId] + ".css";
};